// ===============================
// Lenis
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    // Treat tablets (e.g. iPad) as touch devices so Lenis doesn't intercept swipes
    // that should trigger the section-transition morph animation.
    const isTouchDevice = isMobile || window.matchMedia("(pointer: coarse)").matches;

    const lenis = new Lenis({
      // Softer smoothing on mobile so scrolling feels quicker and less "heavy"
      duration: isMobile ? 0.45 : 1.5,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      smoothTouch: isTouchDevice ? false : true,
      wheelMultiplier: isMobile ? 0.6 : 0.4,
      infinite: false,
    });

    // Make Lenis accessible globally
    window.lenis = lenis;

    lenis.on("scroll", ScrollTrigger.update);

    // Sync ScrollTrigger with Lenis scroll position
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.scrollerProxy(document.body, {
        scrollTop(value) {
          return arguments.length ? lenis.scrollTo(value) : lenis.scroll;
        },
        getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
          };
        },
      });
    }

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    // Section transition flow controls Lenis state when needed.
  });
})();